import React from 'react';
import styled from 'styled-components';

const LightGreenCalendar = () => {
return(
    <Container>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.20308 16H13.7969C15.0123 16 16 15.0489 16 13.8785V3.30665C16 2.13628 15.0123 1.18516 13.7969 1.18516H12.9231V0.592582C12.9231 0.266652 12.6461 0 12.3077 0C11.9692 0 11.6923 0.266652 11.6923 0.592582V1.18516H4.30771V0.592582C4.30771 0.266652 4.03075 0 3.69229 0C3.35382 0 3.07692 0.266652 3.07692 0.592582V1.18516H2.20308C0.9877 1.18516 0 2.13628 0 3.30665V13.8785C0 15.0489 0.9877 16 2.20308 16ZM1.2308 3.30665C1.2308 2.79111 1.66771 2.37038 2.20308 2.37038H3.07692V2.96296C3.07692 3.28889 3.35382 3.55554 3.69229 3.55554C4.03075 3.55554 4.30766 3.28889 4.30766 2.96296V2.37038H11.6923V2.96296C11.6923 3.28889 11.9692 3.55554 12.3077 3.55554C12.6461 3.55554 12.923 3.28889 12.923 2.96296V2.37038H13.7969C14.3322 2.37038 14.7692 2.79111 14.7692 3.30665V5.03704H1.2308V3.30665ZM1.2308 6.22221H14.7693V13.8785C14.7693 14.3941 14.3323 14.8148 13.797 14.8148H2.20308C1.66771 14.8148 1.2308 14.3941 1.2308 13.8785V6.22221Z"
                fill="#BAFFC9"/>
        </svg>
    </Container>
)

}
export default LightGreenCalendar;

const Container = styled.div`

`;